import Repository from '@/repositories/RepositoryFactory';
import ENUM from '../../enums/APISTATE';
import Vue from 'vue';

const EmployeesRepository = Repository.get('employees');

export default ({
  namespaced: true,
  state: {
    employeeApiState: ENUM.INIT,
    employees: [],
    replacementApiState: ENUM.INIT,
    replacements: [],
    replacementsForDateApiState: ENUM.INIT,
    replacementsForDate: [],
    allEmployeeApiState: ENUM.INIT,
    allEmployees: [],
    allEmployeesDict: {},
    availableEmployees: [],
    availableEmployeesApiState: ENUM.INIT,
  },
  mutations: {
    setReplacementApiState: (state, apiState) => {
      state.replacementApiState = apiState;
    },
    setEmployeeApiState: (state, apiState) => {
      state.employeeApiState = apiState;
    },
    setEmployees(state, employees) {
      state.employees = employees;
      state.employeeApiState = ENUM.LOADED;
    },
    setReplacements(state, response) {
      const { data } = response;
      state.replacements = data;
      state.replacementApiState = ENUM.LOADED;
    },
    setReplacementsForDateApiState: (state, apiState) => {
      state.replacementsForDateApiState = apiState;
      if(apiState === ENUM.LOADING) {
        state.replacementsForDate = [];
      }
    },
    setReplacementsForDate(state, response) {
      const { data } = response;
      state.replacementsForDate = data;
      state.replacementsForDateApiState = ENUM.LOADED;
    },
    setAllEmployeeApiState: (state, apiState) => {
      state.allEmployeeApiState = apiState;
    },
    setAllEmployees(state, response) {
      state.allEmployees = response;
      state.allEmployeesDict = {};
      response.forEach(employee => Vue.set(state.allEmployeesDict, employee.id, employee));
      state.allEmployeeApiState = ENUM.LOADED;
    },
    setAvailableEmployees(state, response) {
      const {data} = response;
      state.availableEmployees = data;
      state.availableEmployeesApiState = ENUM.LOADED;
    },
    setAvailableEmployeesApiState(state, apiState) {
      state.availableEmployeesApiState = apiState;
    }
  },
  actions: {
    loadEmployees({ commit }) {
      commit('setEmployeeApiState', ENUM.LOADING);
      return new Promise((resolve, reject) => {
        EmployeesRepository.getActive().then((response) => {
          commit('setEmployees', response);
          resolve();
        }).catch((error) => {
          console.error(error);
          commit('setEmployeeApiState', ENUM.ERROR);
          reject();
        });
      });
    },
    employeesForMyCalendar({ commit }) {
      commit('setEmployeeApiState', ENUM.LOADING);
      return new Promise((resolve, reject) => {
        EmployeesRepository.employeesForMyCalendar().then((response) => {
          commit('setEmployees', response);
          resolve();
        }).catch((error) => {
          console.error(error);
          commit('setEmployeeApiState', ENUM.ERROR);
          reject();
        });
      });
    },
    loadReplacements({ commit }) {
      commit('setReplacementApiState', ENUM.LOADING);
      return new Promise((resolve, reject) => {
        EmployeesRepository.getReplacements().then((response) => {
          commit('setReplacements', response);
          resolve();
        }).catch((error) => {
          console.error(error);
          commit('setReplacementApiState', ENUM.ERROR);
          reject();
        });
      });
    },
    loadReplacementsFromDate({ commit }, request) {
      if(!request || !request.date) {
        return;
      }

      commit('setReplacementsForDateApiState', ENUM.LOADING);
      return new Promise((resolve, reject) => {
        EmployeesRepository.getReplacementsForDate(request.date, request.region).then((response) => {
          commit('setReplacementsForDate', response);
          resolve();
        }).catch((error) => {
          console.error(error);
          commit('setReplacementsForDateApiState', ENUM.ERROR);
          reject();
        });
      });
    },
    async setAllEmployees({commit}, employees){
      commit('setAllEmployees', employees);
    },
    async getAllEmployees({ commit }) {
      commit('setAllEmployeeApiState', ENUM.LOADING);
      try {
        const { data }  =  await EmployeesRepository.getAllEmployees();
        commit('setAllEmployees', data);
      }
      catch (error) {
        console.error(error);
        commit('setAllEmployeeApiState', ENUM.ERROR);
      }
    },
    async getEmployees({ commit }) {
      commit('setEmployeeApiState', ENUM.LOADING);
      return new Promise((resolve, reject) => {
        EmployeesRepository.getEmployees().then((response) => {
          commit('setEmployees', response);
          resolve();
        }).catch((error) => {
          console.error(error);
          commit('setEmployeeApiState', ENUM.ERROR);
          reject();
        });
      });
    },
    async getAvailableEmployees({commit}, {forGroup, forDate}) {
      commit('setAvailableEmployeesApiState', ENUM.LOADING);
      try {
        commit('setAvailableEmployees', await EmployeesRepository.getAvailableEmployees(forGroup, forDate));
      }
      catch (error) {
        console.error(error);
        commit('setAvailableEmployeesApiState', ENUM.ERROR);
      }
    }
  },
  getters: {
    employeeApiState(state) {
      return state.employeeApiState;
    },
    replacementApiState(state) {
      return state.replacementApiState;
    },
    employees(state) { 
      return state.employees; 
    },
    replacements(state) {
      return state.replacements;
    },
    replacementsForDateApiState(state) {
      return state.replacementsForDateApiState;
    },
    replacementsForDate(state) {
      return state.replacementsForDate;
    },
    allEmployeeApiState(state) {
      return state.allEmployeeApiState;
    },
    allEmployees(state) { 
      return state.allEmployees; 
    },
    availableEmployees(state) {
      return state.availableEmployees;
    },
    allEmployeesLookup: state => (employeeId) => state.allEmployeesDict[employeeId],

  }
});
